import FormValidation from '@/js/components/forms/formValidation';

class Account {
  constructor() {
    this.dom = {
      formLogin: document.getElementById('form-account-login'),
      formRegistration: document.getElementById('form-account-registration'),
      formPasswordForget: document.getElementById('form-account-password-forget'),
      formPasswordReset: document.getElementById('form-account-password-reset'),
      formChangePassword: document.getElementById('form-account-change-password'),
      updateAccount: document.getElementById('form-account-update'),
      updateReportPreferencesAccount: document.getElementById('form-account-report-update'),
    };

    this.components = {
      validation: null,
    };
  }

  mount() {
    Object.values(this.dom).find((element) => {
      if (!(element instanceof HTMLFormElement)) {
        return false;
      }

      this.components.validation = new FormValidation(element);
      return true;
    });
  }
}

if (document.getElementById('page-login') || document.getElementById('page-account')) {
  new Account().mount();
}
